<!--<footer class="footer">-->
  <div class="container-fluid" style="background-color:rgb(242,242,242) !important;height:55px!important;margin-bottom:1px!important;">
    <div class="row">
      <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
      </div>
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div style="width: 50px;height: 50px;" class="col-2">
            <div class="main-btn rounded-circle" title="Cancel" style="margin: 0px auto;" rel="tooltip" data-placement="top">
              <div class="app-cancel" *ngIf="type!='permittype'" (click)="changeView(1,0,0)"></div>
              <div class="app-cancel" *ngIf="type=='permittype'" (click)="navigateUrl('/permit/approval')"></div>
            </div>
            <div class="lbl-app" style="margin: 1px auto;">
              <span>Cancel</span>
            </div>
          </div>
          <div style="width: 50px;height: 50px;" class="col-2">
            <div class="main-btn rounded-circle" title="Additional information required" style="margin: 0px auto;" rel="tooltip" data-placement="top">
              <div id="info-add" *ngIf="type!='permittype'" (click)="changeView(3,1,5)"></div>
              <div id="info-add" *ngIf="type=='permittype'" (click)="navigateUrlId('/permit/approval/correspondence',5,1)"></div>
            </div>
            <div class="lbl-app" style="margin: 1px auto;">
              <span>Additional info</span>
            </div>
          </div>
          <div style="width: 50px;height: 50px;" class="col-2">
            <div class="main-btn rounded-circle" title="Approve application" style="margin: 0px auto;" rel="tooltip" data-placement="top">
              <div id="approve-app" *ngIf="type!='permittype'" (click)="changeView(3,2,21)"></div>
              <div id="approve-app" *ngIf="type=='permittype'" (click)="navigateUrlId('/permit/approval/correspondence',21,2)"></div>
            </div>
            <div class="lbl-app" style="margin: 1px auto;">
              <span>Approve</span>
            </div>
          </div>
        <!--  <div style="width: 50px;height: 50px;" class="col-2">
            <div class="main-btn rounded-circle" title="Escalate application" style="margin:0px auto;" rel="tooltip" data-placement="top">
              <div id="escalate" *ngIf="type!='permittype'" (click)="changeView(3,3,0)"></div>
              <div id="escalate" *ngIf="type=='permittype'" (click)="navigateUrlId('/permit/approval/correspondence',0,3)"></div>
            </div>
            <div class="lbl-app" style="margin: 1px auto;">
              <span>Escalate</span>
            </div>
          </div>-->
          <!-- <div style="width: 50px;height: 50px;" class="col-2">
            <div class="main-btn rounded-circle" title="Edit application" style="margin: 0px auto;" rel="tooltip" data-placement="top">
              <div id="edit-app" *ngIf="type!='permittype'" (click)="changeView(3,4,0)"></div>
              <div id="edit-app" *ngIf="type=='permittype'" (click)="navigateUrlId('/permit/approval/correspondence',0,4)"></div>
            </div>
            <div class="lbl-app" style="margin: 1px auto;">
              <span>Update</span>
            </div>
          </div> -->
          <div style="width: 50px;height: 50px;" class="col-2">
            <div class="main-btn rounded-circle" title="Change status" style="margin: 0px auto;" rel="tooltip" data-placement="top">
              <div id="change-app" *ngIf="type!='permittype'" (click)="changeView(3,5,0)"></div>
              <div id="change-app" *ngIf="type=='permittype'" (click)="navigateUrlId('/permit/approval/correspondence',0,5)"></div>
            </div>
            <div class="lbl-app" style="margin: 1px auto;padding:0px;">
              <span style="margin: 0px;padding:0px;">Change status</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
<!--</footer>-->

<!-- OTP popup -->
<button data-toggle="modal" data-target="#addEdit" id="secretButton" style="display:none"></button>

<div class="modal fade form-group" id="addEdit" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="text-center title">Enter verification code</label>
                <button type="button" class="close" data-dismiss="modal" id="closeButton" #closebutton aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-xl">
                <form>

                    <div class="row test">
                        <div class="col-12 sp-fld">
                            <div class="text-center">
                                <p id="OtpMessage"></p>
                                <input class="form-control input-sm text-center" type="number" id="OTPCode" maxlength="6" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">

                        <button type="button" class="btn btn-primary btn-block mt-4 mb-4" (click)="verifyOtp()">Confirm</button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>
